import { configureStore } from "@reduxjs/toolkit";

import { DEV_MODE } from "../../Constant/app/process";
import appSlice from "../slices/app/app.slice";
import dashboardDatasSlice from "../slices/dashboardDatas/dashboardDatas.slice";
import destinationsSlice from "../slices/destinations/destinations.slice";
import destinationsTypesSlice from "../slices/destinationsTypes/destinationsTypes.slice";
import isLoginSlice from "../slices/isLogin/isLogin.slice";
import landingPagesSlice from "../slices/landingPages/landingPages.slice";
import landingReportsSlice from "../slices/landingReports/landingReports.slice";
import languagesSlice from "../slices/languages/languages.slice";
import leadConnectionSlice from "../slices/leadConnection/leadConnection.slice";
import leadDebugSlice from "../slices/leadDebug/leadDebug.slice";
import leadHistorySlice from "../slices/leadHistory/leadHistory.slice";
import leadDestinationsSlice from "../slices/leadDestinations/leadDestinations.slice";
import leadReportsSlice from "../slices/leadReports/leadReports.slice";
import leadServiceSlice from "../slices/leadService/leadService.slice";
import leadSourcesSlice from "../slices/leadSources/leadSources.slice";
import leadsWizardSourceDestinationSlice from "../slices/leadsWizardSourceDestination/leadsWizardSourceDestination.slice";
import leadZohoCredentialsSlice from "../slices/leadZohoCredentials/leadZohoCredentials.slice";
import modalSlice from "../slices/modal/modal.slice";
import notificationsSlice from "../slices/notifications/notifications.slice";
import setAppIdSlice from "../slices/setAppId/setAppId.slice";
import sourcesSlice from "../slices/sources/sources.slice";
import sourcesTypesSlice from "../slices/sourcesTypes/sourcesTypes.slice";
import step1DatasSlice from "../slices/step1Datas/step1Datas.slice";
import templatesSlice from "../slices/templates/templates.slice";
import testEventsSlice from "../slices/testEvents/testEvents.slice";
import trackerEventsSlice from "../slices/trackerEvents/trackerEvents.slice";
import trackersSlice from "../slices/trackers/trackers.slice";
import trackerSettingsSlice from "../slices/trackerSettings/trackerSettings.slice";
import wizardSourceDestinationSlice from "../slices/wizardSourceDestination/wizardSourceDestination.slice";
import logger from "./logger";

const middlewares = DEV_MODE ? [logger] : [];

export const store = configureStore({
    reducer: {
        app: appSlice,
        allSourcesTypesState: sourcesTypesSlice,
        allDestinationsTypeState: destinationsTypesSlice,
        allTrackersState: trackersSlice,
        allSourcesState: sourcesSlice,
        allDestinationsState: destinationsSlice,
        isLogin: isLoginSlice,
        allDashboardDatasState: dashboardDatasSlice,
        lastAddedSourceDestinationState: wizardSourceDestinationSlice,
        languagesState: languagesSlice,
        leadslastAddedSourceDestinationState: leadsWizardSourceDestinationSlice,
        leadAllSourcesState: leadSourcesSlice,
        setAppId: setAppIdSlice,
        leadAllDestinationsState: leadDestinationsSlice,
        stepOneDatas: step1DatasSlice,
        leadAllConnectionState: leadConnectionSlice,
        leadAllLeadServiceState: leadServiceSlice,
        notificationsState: notificationsSlice,
        leadZohoCredentialSlice: leadZohoCredentialsSlice,
        templates: templatesSlice,
        leadReports: leadReportsSlice,
        leadDebug: leadDebugSlice,
        leadHistory: leadHistorySlice,
        testEvents: testEventsSlice,
        landingPages: landingPagesSlice,
        landingPageReports: landingReportsSlice,
        trackerSettings: trackerSettingsSlice,
        trackerEvents: trackerEventsSlice,
        modal: modalSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(...middlewares),
});
